import type { UserDTO } from "@/models/dtos/user-dto.ts";
import { getUserRoleFlags } from "./user-utils";
import type { RoleDto } from "@/models/dtos/roles-dto";
import { Role } from "@/models/enums/role";

export function isOneAdmin(user: UserDTO | undefined): boolean {
  return getUserRoleFlags(user).isOneAdmin;
}

export function isOneUser(user: UserDTO | undefined): boolean {
  return getUserRoleFlags(user).isOneUser;
}

export function isOneUserAdmin(user: UserDTO | undefined): boolean {
  return getUserRoleFlags(user).isOneUserAdmin;
}

export function isCustomerAdminForAtLeastOneCustomer(
  user: UserDTO | undefined,
): boolean {
  return !!user?.roles.some((r: RoleDto) => r.role === Role.CUSTOMER_ADMIN);
}

export function isCustomerAdminForCustomer(
  user: UserDTO | undefined,
  customerNumber: string,
): boolean {
  return getUserRoleFlags(user, customerNumber).isCustomerAdmin;
}

export function isUserForAtLeastOneCustomer(
  user: UserDTO | undefined,
): boolean {
  return !!user?.roles.some((r: RoleDto) => r.role === Role.USER);
}

export function isUserForCustomer(
  user: UserDTO | undefined,
  customerNumber: string,
): boolean {
  return getUserRoleFlags(user, customerNumber).isUser;
}

export function userCustomerIds(user: UserDTO | undefined): string[] {
  return [
    ...new Set(user?.roles.map((r) => r.customerNumber).filter(Boolean)),
  ] as string[];
}
